import { configureStore } from '@reduxjs/toolkit';
import authLoginReducer from './slices/Auth/LoginSlice';
import languageSlice from "./language/languageSlice";
import authOtpReducer from './slices/Auth/OtpSlice';
import resetResendOtp from "./slices/Auth/ResendOtpSlice";
import healthInsuranceSlice from "./slices/Health_Insurance_Card/HealthCardSlice";
import insuranceCertificateSlice from "./slices/Insurance_Certificate/InsuranceCertificateSlice";
import documentsSlice from "./slices/Auth/DocumentSlice";
import medicalRequestsReducer from './slices/Medical_Requests/MedicalrequestSlice';
import ContactReducer from './slices/Contact/Index';
import hospitalsSliceReducer from './slices/Hospital/Index';
import doctorAppointmentReducer from './slices/Doctor_Appointment/Index';
import branchesSliceReducer from './slices/Branches/Index';
import feedbackReducer from './slices/FeedBack/Index';

export const store = configureStore({
  reducer: {
    authLogin: authLoginReducer,
    language: languageSlice,
    authOtp: authOtpReducer,
    resendOtp: resetResendOtp,
    healthInsurance: healthInsuranceSlice,
    insurancePolicy: insuranceCertificateSlice,
    documents: documentsSlice,
    medicalRequests: medicalRequestsReducer,
    contact: ContactReducer,
    hospitals: hospitalsSliceReducer,
    doctorAppointment: doctorAppointmentReducer,
    branches: branchesSliceReducer,
    feedback: feedbackReducer,
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;